import "./sliderAlarm.css";
import { useEffect, useRef } from "react";
import playLeft from "../../picture/play-left.png";
import playRight from "../../picture/play-right.png";
import { compareAsc } from "date-fns";
import { MarkEmailRead } from "@mui/icons-material";

const SliderAlarm = ({
  setAlarmTime,
  currentNotification,
  isEditing,
  selectedDate,
  notificationsList,
}) => {
  let marker, currentTime;
  const startMoving = useRef();
  const termWidth = useRef();
  const removed = useRef();
  const isFromAdmin = useRef();
  const isAlarmPosition = useRef();

  const handleStartMoving = (e) => {
    const arrows = document.querySelectorAll(".arrow-alarm");
    arrows.forEach((arrow) => arrow.remove());

    const markers = document.querySelectorAll(".slider-alarm-marker");
    markers.forEach((marker) => {
      if (marker !== e.currentTarget) marker.remove();
    });

    let timeSpan;
    if (e.currentTarget.classList.contains("start")) {
      timeSpan = document.querySelector(".span-end-alarm");
      if (timeSpan !== null) timeSpan.remove();
    } else {
      timeSpan = document.querySelector(".span-start-alarm");
      if (timeSpan !== null) timeSpan.remove();
    }

    isFromAdmin.current = true;
    e.currentTarget.addEventListener("mousemove", handleMoving);
  };

  const handleMoving = (e) => {
    if (isFromAdmin.current) {
      isAlarmPosition.current = true;
      const sliderMarkers = document.querySelector(".slider-alarm-markers");
      const movingElement = e.currentTarget;
      const dot = document.querySelector(".red-dot-alarm");
      const endDot = document.querySelector(".red-dot-alarm-end");
      const sliderLine = document.querySelector(".slider-alarm-line");
      const sliderLeft = sliderLine.getBoundingClientRect().left;
      if (
        dot &&
        e.clientX <
          dot.getBoundingClientRect().left +
            dot.getBoundingClientRect().width / 2
      ) {
        movingElement.style.left = `${
          dot.getBoundingClientRect().left -
          dot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;
        movingElement.classList.add("animate");
        movingElement.removeEventListener("mouseup", handleStopMoving);
      } else if (
        endDot &&
        e.clientX >
          endDot.getBoundingClientRect().left +
            endDot.getBoundingClientRect().width / 2
      ) {
        movingElement.style.left = `${
          endDot.getBoundingClientRect().left -
          endDot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;
        movingElement.classList.add("animate");
        movingElement.removeEventListener("mouseup", handleStopMoving);
      } else if (
        e.clientX - startMoving.current <
        sliderMarkers.getBoundingClientRect().left - startMoving.current
      ) {
        movingElement.style.left = `${
          -movingElement.getBoundingClientRect().width / 2
        }px`;
      } else if (
        e.clientX - startMoving.current >
        sliderMarkers.getBoundingClientRect().right - startMoving.current
      ) {
        movingElement.style.left = `${
          sliderMarkers.getBoundingClientRect().right - startMoving.current
        }px`;
      } else {
        movingElement.style.left = `${e.clientX - startMoving.current}px`;
        const rect = movingElement.getBoundingClientRect();
        marker = {
          pin: movingElement,
          width: rect.width,
          position: rect.left + rect.width - startMoving.current,
        };
        calculateTime(movingElement);
        updateTimeSpan(movingElement);
      }
    }
  };

  const createSetting = (movingElement, validation) => {
    let arrow = document.createElement("img");
    arrow.src = playLeft;
    arrow.classList.add("arrow-alarm");
    arrow.style.left = `${
      movingElement.getBoundingClientRect().left -
      startMoving.current -
      movingElement.getBoundingClientRect().width / 2
    }px`;
    arrow.addEventListener("click", (e) => handleDecreaseMinutes(e));
    movingElement.parentNode.appendChild(arrow);

    arrow = document.createElement("img");
    arrow.src = playRight;
    arrow.classList.add("arrow-alarm");
    arrow.style.left = `${
      movingElement.getBoundingClientRect().right -
      startMoving.current +
      movingElement.getBoundingClientRect().width / 4
    }px`;
    arrow.addEventListener("click", (e) => handleIncreaseMinutes(e));
    movingElement.parentNode.appendChild(arrow);
  };

  const handleStopMoving = (e) => {
    const validation = {
      isValidated: true,
    };
    e.currentTarget.removeEventListener("mousemove", handleMoving);
    e.currentTarget.style.backgroundColor = "green";

    calculateTimeWithMinutes(e.currentTarget);
    isFromAdmin.current = false;
    updateTimeSpan(e.currentTarget);

    const sliderMarkers = document.querySelector(".slider-alarm-markers");
    let time = sliderMarkers.parentNode.querySelector("span").innerHTML;
    let hours = time.split(":")[0];
    let minutes = time.split(":")[1];
    let year = selectedDate.getYear();
    let month = selectedDate.getMonth();
    let day = selectedDate.getDay();
    let date = new Date(year, month, day, hours, minutes);
    console.log(selectedDate);

    setAlarmTime(sliderMarkers.parentNode.querySelector("span").innerHTML);

    createSetting(sliderMarkers.parentNode.querySelector("span"), validation);
  };

  const calculateTimeWithMinutes = (movingElement) => {
    const slider = document
      .querySelector(".slider-alarm-line")
      .getBoundingClientRect();
    let timePosition;
    let timeWidth = termWidth.current / 60;
    timePosition =
      movingElement.getBoundingClientRect().left +
      movingElement.getBoundingClientRect().width / 2;

    let hours = parseInt((timePosition - slider.left) / timeWidth / 60);
    let minutes = parseInt(((timePosition - slider.left) / timeWidth) % 60);

    let correctHours, correctMinutes;

    if (hours < 10) correctHours = `0${hours}`;
    else correctHours = `${hours}`;
    if (minutes < 10) correctMinutes = `0${minutes}`;
    else correctMinutes = `${minutes}`;
    currentTime = correctHours + ":" + correctMinutes;
  };

  const handleIncreaseMinutes = (e) => {
    const slider = document
      .querySelector(".slider-alarm-line")
      .getBoundingClientRect();
    const timeSpan = e.currentTarget.parentNode.querySelector("span");
    const marker = e.currentTarget.parentNode.parentNode.querySelector(
      ".slider-alarm-markers"
    ).firstChild;

    const arrows = document.querySelectorAll(".arrow-alarm");
    const time = timeSpan.innerHTML.split(":");

    let minutes = parseInt(time[1]);
    let hours = parseInt(time[0]);

    if (hours === 24) {
      /* if (arrows.length !== 0) arrows.forEach((arrow) => arrow.remove());
      movingElement.style.left = `${
        0 * termWidth.current - movingElement.getBoundingClientRect().width / 2
      }px`;
      movingElement.style.backgroundColor = "gray";*/
      return;
    }
    let timeNotification = currentNotification.startTime;
    if (timeNotification === "") {
      timeNotification = currentNotification.endTime;
    }

    const currentHourse = parseInt(timeNotification.split(":")[0]);

    const currentMinutes = parseInt(timeNotification.split(":")[1]);

    if (hours >= currentHourse && minutes >= currentMinutes) {
      return;
    }

    minutes = minutes + 1;

    if (minutes >= 60) {
      minutes = 0;
      hours += 1;
    }

    let timeWidth = termWidth.current / 60;

    marker.style.left = `${
      marker.getBoundingClientRect().left + timeWidth - slider.left
    }px`;

    timeSpan.style.left = `${
      timeSpan.getBoundingClientRect().left + timeWidth - slider.left
    }px`;

    arrows[0].style.left = `${
      timeSpan.getBoundingClientRect().left +
      timeWidth -
      slider.left -
      +arrows[1].getBoundingClientRect().width -
      3
    }px`;

    arrows[1].style.left = `${
      timeSpan.getBoundingClientRect().right + timeWidth - slider.left + 3
    }px`;

    if (minutes < 10) minutes = `0${minutes}`;
    timeSpan.innerHTML = `${hours}:${minutes}`;
  };

  const handleDecreaseMinutes = (e) => {
    const slider = document
      .querySelector(".slider-alarm-line")
      .getBoundingClientRect();
    const timeSpan = e.currentTarget.parentNode.querySelector("span");
    const marker = e.currentTarget.parentNode.parentNode.querySelector(
      ".slider-alarm-markers"
    ).firstChild;

    const arrows = document.querySelectorAll(".arrow-alarm");
    const time = timeSpan.innerHTML.split(":");

    let minutes = parseInt(time[1]);
    let hours = parseInt(time[0]);

    if (minutes === 0) {
      minutes = 60;
      hours -= 1;
    }

    let correctMinutes;
    let currentHours = new Date().getHours();
    let currentMinutes = new Date().getMinutes();
    if (currentMinutes > 30) {
      correctMinutes = 0;
      currentHours += 1;
    } else {
      correctMinutes = 30;
    }

    if (hours < 0) {
      return;
    }

    if (
      (hours < currentHours && minutes === 60) ||
      (hours === currentHours && minutes === correctMinutes)
    ) {
      return;
    }

    minutes = minutes - 1;

    let timeWidth = termWidth.current / 60;

    marker.style.left = `${
      marker.getBoundingClientRect().left - timeWidth - slider.left
    }px`;

    timeSpan.style.left = `${
      timeSpan.getBoundingClientRect().left - timeWidth - slider.left
    }px`;

    arrows[0].style.left = `${
      timeSpan.getBoundingClientRect().left -
      timeWidth -
      slider.left -
      +arrows[1].getBoundingClientRect().width -
      3
    }px`;

    arrows[1].style.left = `${
      timeSpan.getBoundingClientRect().right - timeWidth - slider.left + 3
    }px`;

    if (minutes < 10) minutes = `0${minutes}`;
    timeSpan.innerHTML = `${hours}:${minutes}`;
  };

  const calculateTime = (movingElement) => {
    const slider = document
      .querySelector(".slider-alarm-line")
      .getBoundingClientRect();
    let timePosition;
    timePosition =
      movingElement.getBoundingClientRect().left +
      movingElement.getBoundingClientRect().width / 2;
    const correctTime = Math.round(
      (timePosition - slider.left) / termWidth.current
    );
    if (correctTime < 10) currentTime = `0${correctTime}:00`;
    else currentTime = `${correctTime}:00`;
  };

  const updateTimeSpan = (movingElement) => {
    let currentSpan;
    if (movingElement.classList.contains("start")) {
      currentSpan = document.querySelector(".span-start-alarm");
      currentSpan.innerHTML = currentTime;
      if (marker === undefined) return;
      currentSpan.style.left = `${
        marker.position - currentSpan.getBoundingClientRect().width / 2
      }px`;
    } else {
      currentSpan = document.querySelector(".span-end-alarm");
      currentSpan.innerHTML = currentTime;
      if (marker === undefined) return;
      currentSpan.style.left = `${
        marker.position - currentSpan.getBoundingClientRect().width / 2
      }px`;
    }
  };

  /*const correctPosition = (movingElement) => {
    const slider = document
      .querySelector(".slider-line")
      .getBoundingClientRect();
    let timePosition =
      movingElement.getBoundingClientRect().left +
      movingElement.getBoundingClientRect().width / 2;
    const correctTime = Math.round((timePosition - slider.left) / termWidth);
    movingElement.style.left = `${
      correctTime * termWidth - movingElement.getBoundingClientRect().width / 2
    }px`;
    marker = {
      pin: movingElement,
      width: startMarker.width,
      position: correctTime * termWidth,
    };
    correctSpanPosition(movingElement);
  };

  const correctSpanPosition = (movingElement) => {
    let currentSpan;
    if (movingElement.classList.contains("start")) {
      currentSpan = document.querySelector(".span-start-alarm");
      currentSpan.style.left = `${
        startMarker.position - currentSpan.getBoundingClientRect().width / 2
      }px`;
    }
  };

  /*const createSetting = (movingElement) => {
    let currentSpan;
    if (movingElement === startMarker?.pin)
      currentSpan = document.querySelector(".span-start-alarm");
    else currentSpan = document.querySelector(".span-end-alarm");
    let arrow = document.createElement("div");
    arrow.classList.add("arrow");
    arrow.classList.add("left");
    arrow.style.left = `${
      currentSpan.getBoundingClientRect().left -
      startMoving -
      currentSpan.getBoundingClientRect().width / 2
    }px`;
    arrow.addEventListener("click", handleDecreaseMinutes);
    currentSpan.parentNode.appendChild(arrow);
    arrow = document.createElement("div");
    arrow.classList.add("arrow");
    arrow.classList.add("right");
    arrow.style.left = `${
      currentSpan.getBoundingClientRect().right -
      startMoving +
      movingElement.getBoundingClientRect().width
    }px`;
    arrow.addEventListener("click", handleIncreaseMinutes);
    currentSpan.parentNode.appendChild(arrow);
  };*/

  const fillLines = () => {
    const sliderLine = document.querySelector(".slider-alarm-line-podeok");
    for (let i = 0; i < 24; i++) {
      let div = document.createElement("div");
      div.classList.add("slider-alarm-podeok");
      div.style.display = "none";
      div.style.width = `${termWidth.current}px`;
      sliderLine.appendChild(div);
    }
    correctMarkerPositions();
  };

  const correctSpanPositions = (movingElement) => {
    let currentSpan;
    if (movingElement.classList.contains("start")) {
      currentSpan = document.querySelector(".span-start-alarm");
      currentSpan.style.left = `${
        marker.position - currentSpan.getBoundingClientRect().width / 2
      }px`;
    } else {
      currentSpan = document.querySelector(".span-end-alarm");
      currentSpan.style.left = `${
        marker.position - currentSpan.getBoundingClientRect().width / 2
      }px`;
    }
  };

  const correctMarkerPositions = () => {
    let markerRect = document.querySelector(".slider-alarm-marker.start");
    const dot = document.querySelector(".red-dot-alarm");
    const endDot = document.querySelector(".red-dot-alarm-end");
    const sliderLine = document.querySelector(".slider-alarm-line");
    const sliderLeft = sliderLine.getBoundingClientRect().left;
    let span = document.querySelector(".span-start-alarm");
    let spanEnd = document.querySelector(".span-end-alarm");

    if (markerRect === null) {
      markerRect = document.querySelector(".slider-alarm-marker.end");
      span = spanEnd;
    }

    let correctMinutes;
    let currentHours = new Date().getHours();
    let currentMinutes = new Date().getMinutes();
    if (currentMinutes > 30) {
      correctMinutes = "00";
      currentHours += 1;
    } else {
      correctMinutes = 30;
    }

    if (dot !== null) {
      if (markerRect.style.backgroundColor !== "green") {
        markerRect.style.left = `${
          dot.getBoundingClientRect().left -
          dot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;
        span.style.left = `${
          dot.getBoundingClientRect().left +
          dot.getBoundingClientRect().width / 2 -
          span.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;
        span.innerHTML = `${currentHours}:${correctMinutes}`;
      } else if (
        markerRect.getBoundingClientRect().left <
        dot.getBoundingClientRect().left
      ) {
        markerRect.style.left = `${
          dot.getBoundingClientRect().left -
          dot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;
        span.style.left = `${
          dot.getBoundingClientRect().left +
          dot.getBoundingClientRect().width / 2 -
          span.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;
        span.innerHTML = `${currentHours}:${correctMinutes}`;

        const arrows = document.querySelectorAll(".arrow-alarm");
        arrows.forEach((arrow) => arrow.remove());

        createSetting(span);
      }
    } else if (endDot !== null) {
      if (
        markerRect.getBoundingClientRect().left >
        endDot.getBoundingClientRect().left
      ) {
        markerRect.style.left = `${
          endDot.getBoundingClientRect().left -
          endDot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;

        span.style.left = `${
          endDot.getBoundingClientRect().left +
          endDot.getBoundingClientRect().width / 2 -
          span.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;
        let startTime;
        if (currentNotification.startTime === "") {
          startTime = currentNotification.endTime;
        } else {
          startTime = currentNotification.startTime;
        }

        currentHours = parseInt(startTime.split(":")[0]);
        correctMinutes = parseInt(startTime.split(":")[1]);

        span.innerHTML = `${currentHours}:${correctMinutes}`;

        const arrows = document.querySelectorAll(".arrow-alarm");
        arrows.forEach((arrow) => arrow.remove());

        createSetting(span);
      } else if (markerRect.style.backgroundColor !== "green") {
        span.style.left = `${-span.getBoundingClientRect().width / 2}px`;
        markerRect.style.left = `${
          -markerRect.getBoundingClientRect().width / 2
        }px`;
      }
    } else {
      if (markerRect.style.backgroundColor !== "green") {
        markerRect.style.left = `${
          -markerRect.getBoundingClientRect().width / 2
        }px`;
        span.style.left = `${-span.getBoundingClientRect().width / 2}px`;
      }
    }

    if (endDot !== null) {
      if (
        markerRect !== null &&
        compareAsc(selectedDate, new Date()) === 0 &&
        markerRect.style.backgroundColor === "green"
      )
        return;

      if (spanEnd !== null) {
        spanEnd.style.left = `${
          endDot.getBoundingClientRect().left +
          endDot.getBoundingClientRect().width / 4 -
          spanEnd.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;
        let currentTime = currentNotification.startTime;

        if (currentTime === "") {
          currentTime = currentNotification.endTime;
        }

        spanEnd.innerHTML = `${currentTime.split(":")[0]}:${
          currentTime.split(":")[1]
        }`;

        const arrows = document.querySelectorAll(".arrow-alarm");
        if (arrows.length > 0) {
          arrows.forEach((arrow) => arrow.remove());
          createSetting(span);
        }
      }

      if (
        spanEnd !== null &&
        spanEnd !== span &&
        spanEnd.getBoundingClientRect().left <
          span.getBoundingClientRect().right
      ) {
        spanEnd.style.left = `${
          span.getBoundingClientRect().right +
          endDot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;
      }

      markerRect = document.querySelector(".slider-alarm-marker.end");
      if (markerRect !== null) {
        markerRect.style.left = `${
          endDot.getBoundingClientRect().left -
          endDot.getBoundingClientRect().width / 4 -
          sliderLeft
        }px`;
      }
    } else {
      if (spanEnd !== null) {
        spanEnd.style.right = `${-spanEnd.getBoundingClientRect().width / 2}px`;
      }
      let endMarker = document.querySelector(".end");
      if (endMarker !== null && endMarker.style.backgroundColor !== "green") {
        spanEnd.style.left = `${
          sliderLine.getBoundingClientRect().right -
          spanEnd.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;
        spanEnd.innerHTML = "24:00";
        endMarker.style.left = `${
          sliderLine.getBoundingClientRect().right -
          endMarker.getBoundingClientRect().width / 2 -
          sliderLeft
        }px`;
      }
    }

    markerRect = document.querySelector(".slider-alarm-marker.end");
    if (markerRect !== null) {
      markerRect.style.right = `${
        -markerRect.getBoundingClientRect().width / 2
      }px`;
    }
  };

  const calculateWidthTerm = () => {
    const slider = document
      .querySelector(".slider-alarm-line")
      .getBoundingClientRect();
    termWidth.current = slider.width / 24;
  };

  const correctMarkerPositionChangeDot = () => {
    const dot = document.querySelector(".red-dot-alarm");
    const sliderMarkers = document.querySelector(".slider-alarm-marker.start");

    if (sliderMarkers === undefined) return;

    const sliderLeft = document
      .querySelector(".slider-alarm-line")
      .getBoundingClientRect().left;

    sliderMarkers.style.left = `${
      dot.getBoundingClientRect().left -
      dot.getBoundingClientRect().width / 4 -
      sliderLeft
    }px`;

    // correctSpanPositionsNull(sliderMarkers);
  };

  const calculateDotPosition = () => {
    const sliderLine = document.querySelector(".slider-alarm-line");
    let correctDotLeft, currentHours, currentMinutes, corectMinutes;
    currentHours = new Date().getHours();
    currentMinutes = new Date().getMinutes();
    if (currentMinutes > 30) {
      corectMinutes = 0;
      currentHours += 1;
    } else {
      corectMinutes = 30;
    }
    correctDotLeft =
      currentHours * termWidth.current +
      (termWidth.current / 60) * corectMinutes;

    const dotDiv = document.createElement("div");
    dotDiv.classList.add("red-dot-alarm");
    sliderLine.appendChild(dotDiv);

    const dotPosition =
      correctDotLeft - dotDiv.getBoundingClientRect().width / 2;
    dotDiv.style.left = `${dotPosition}px`;

    if (currentMinutes === 0 || currentMinutes === 30)
      correctMarkerPositionChangeDot();
  };

  const calculateStartTerminDotPosition = () => {
    const sliderLine = document.querySelector(".slider-alarm-line");
    let correctDotLeft, currentHours, correctMinutes;

    let startTime;
    if (currentNotification.startTime === "") {
      startTime = currentNotification.endTime;
    } else {
      startTime = currentNotification.startTime;
    }

    currentHours = parseInt(startTime.split(":")[0]);
    correctMinutes = parseInt(startTime.split(":")[1]);

    correctDotLeft =
      currentHours * termWidth.current +
      (termWidth.current / 60) * correctMinutes;

    const dotDiv = document.createElement("div");
    dotDiv.classList.add("red-dot-alarm-end");
    sliderLine.appendChild(dotDiv);

    const dotPosition =
      correctDotLeft - dotDiv.getBoundingClientRect().width / 2;
    dotDiv.style.left = `${dotPosition}px`;
  };

  const calculateNewPosition = () => {
    let markerRect = document.querySelector(".slider-alarm-marker.start");
    console.log(currentNotification.alarmTime);
    if (currentNotification.alarmTime !== "") {
      marker = {
        pin: markerRect,
        width: markerRect.getBoundingClientRect().width,
        position:
          termWidth.current *
          parseInt(currentNotification.alarmTime.split(":")[0]),
      };

      markerRect.style.left = `${marker.position - marker.width / 2}px`;
      markerRect.style.backgroundColor = "green";
      let span = document.querySelector(".span-start-alarm");

      let endMarker = document.querySelector(".slider-alarm-marker.end");
      let endSpan = document.querySelector(".span-end-alarm");
      if (endMarker !== null) endMarker.remove();
      if (endSpan !== null) endSpan.remove();

      span.style.left = `${
        marker.position - span.getBoundingClientRect().width / 2
      }px`;

      span.innerHTML = `${currentNotification.alarmTime.split(":")[0]}:${
        currentNotification.alarmTime.split(":")[1]
      }`;
    }
  };

  useEffect(() => {
    const dot = document.querySelector(".red-dot-alarm");
    if (dot !== null) dot.remove();

    const dotEnd = document.querySelector(".red-dot-alarm-end");
    if (dotEnd !== null) dotEnd.remove();

    calculateWidthTerm();

    if (
      compareAsc(
        new Date(new Date().setHours(0, 0, 0, 0)),
        new Date(new Date(selectedDate).setHours(0, 0, 0, 0))
      ) === 0
    ) {
      calculateDotPosition();
    }
    console.log(notificationsList);
    console.log(currentNotification);
    if (
      compareAsc(
        new Date(new Date().setHours(0, 0, 0, 0)),
        new Date(new Date(selectedDate).setHours(0, 0, 0, 0))
      ) === 0
    ) {
      calculateStartTerminDotPosition();
    }

    fillLines();
    removed.current = false;
    if (isEditing) removed.current = true;

    const sliderMarkers = document.querySelector(".slider-alarm-markers");
    const marker = document.querySelector(".slider-alarm-marker");

    startMoving.current =
      sliderMarkers.getBoundingClientRect().x +
      marker.getBoundingClientRect().width / 2;
    console.log(currentNotification.alarms);
    if (currentNotification.alarms.length !== 0 && !isAlarmPosition.current) {
      calculateNewPosition();
    }
  }, [selectedDate]);

  return (
    <div className="slider-alarm">
      <div className="slider-alarm-time">
        <span className="span-start-alarm">00:00</span>
        <span className="span-end-alarm">24:00</span>
      </div>
      <div className="slider-alarm-line">
        <div className="slider-alarm-line-podeok" />
      </div>
      <div className="slider-alarm-markers">
        <div
          className="slider-alarm-marker start"
          onMouseDown={(e) => handleStartMoving(e)}
          onMouseUp={(e) => handleStopMoving(e)}
        />
        <div
          className="slider-alarm-marker end"
          onMouseDown={(e) => handleStartMoving(e)}
          onMouseUp={(e) => handleStopMoving(e)}
        />
      </div>
    </div>
  );
};

export default SliderAlarm;
